module.exports = __webpack_public_path__ + "media/src/images/icons/hollow-ellipse-9c9cf42a0a32b33ba82e31d7179cdc70.svg";